<template>
  <div>
    <Button @click="showSelectTeacher=true" type="primary">新增推荐</Button>
    <div class="content">
      <Grid
        ref="grid"
        :columns="tableColumns"
        :data-url="`/api/recommendDetail/${this.id}`"
        :rowsFormatter="onrowsFormatter"
        selectType
        keyField="detail_id"
        method="get"
      >
        <template slot-scope="{row}" slot="action">
          <div>
            <Button type="text" size="small" @click="onSet(row)">{{row.is_top==1?"取消置顶":"置顶"}}</Button>
            <span>-</span>
            <Button type="text" size="small" @click="onDelete(row)">删除</Button>
          </div>
        </template>
      </Grid>
    </div>
    <Modal
      v-model="showSelectTeacher"
      :title="title"
      @on-ok="confirmSelectTeacher"
      width="800"
      scrollable
    >
      <ExerciseSelect ref="exercise" :type='$route.query.type'></ExerciseSelect>
    </Modal>
  </div>
</template>
<script>
import * as enums from "@/utils/enums";
import ExerciseSelect from "@/components/GridSelect/ExerciseSelect";
export default {
  name: "MobileRecomment",
  components: {
    ExerciseSelect
  },
  data() {
    return {
      id: this.$route.query.id,
      tableColumns: [
        { title: "章节练习名称", key: "title", align: "center", minWidth: 160 },
        { title: "所属分类", key: "classify_title", align: "center", minWidth: 160 },
        {
          title: "创建人",
          key: "creator_name",
          align: "center",
          minWidth: 160
        },
        {
          title: "创建时间",
          key: "created_at",
          align: "center",
          minWidth: 160
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          fixed: "right",
          minWidth: 160
        }
      ],
      course_type_name: enums.CouseType.getOptions(),
      showSelectTeacher: false,
      title:'选择章节练习'
    };
  },
  created () {
    if(this.$route.query.type == 8){
      this.tableColumns[0].title = '考试名称';
      this.title = '选择模拟考试'
    }
  },
  methods: {
    onrowsFormatter(rows) {
      rows.forEach(i => {
        (i.course_type_name = enums.CouseType.getValue(i.course_type)),
          (i.created_at = this.$pub.timestampToTime(i.created_at));
      });
    },
    onSet(row) {
      this.$http.put("/api/recommendTop/" + row.detail_id).then(() => {
        this.$Message.success("成功");
        this.search();
      });
    },
    confirmSelectTeacher() {
      this.showSelectTeacher = false;
      let list = this.$refs.exercise.getSelectList();
      if (!list || list.length == 0) {
        return;
      }
      let ids = "";
      list.forEach((item, index) => {
        if (index == list.length - 1) {
          ids += item.id;
        } else {
          ids += item.id + ",";
        }
      });
      this.$http
        .post("/api/recommendDetail", {
          recommend_channel_id: this.id,
          id: ids
        })
        .then(() => {
          this.$refs.exercise.recoverSelectedItems([]);
          this.$Message.success("添加成功!");
          this.search();
        });
    },
    search() {
      this.$refs.grid.searchRefresh();
    },
    onDelete(row) {
      this.$Modal.confirm({
        title: "提示",
        content: "确定删除该推荐吗？",
        onOk: () => {
          this.$http
            .delete("/api/recommendDetail/" + row.detail_id)
            .then(() => {
              this.$Message.success("删除成功!");
              this.search();
            });
        }
      });
    }
  }
};
</script>




